module.exports = __webpack_public_path__ + "static/img/moreFunction2.18e9119.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/moreFunction2.webp
// module id = j4W3
// module chunks = 1